import { apiPaths } from 'configs/apiConfigs'
import useSWRImmutable from 'swr/immutable'
import { getEntities } from './entitiesApi'

export const useEntities = (config?: any) => {
  const { data, error } = useSWRImmutable(apiPaths.entities(), getEntities, config ? { ...config } : {})

  return {
    data,
    error,
    isLoading: !data && !error,
  }
}
